<template>
    <div>
        <Wp_nav_bar title="我的推广预估收入详情"></Wp_nav_bar>
        <Wp_order_count_self_detail_model></Wp_order_count_self_detail_model>
    </div>
</template>

<script>
    import Wp_nav_bar from "../custom/Wp_nav_bar";
    import Wp_order_count_self_detail_model from "./Wp_order_count_self_detail_model";
    export default {
        name: "Wp_order_count_self_detail_page",
        components: {Wp_order_count_self_detail_model, Wp_nav_bar}
    }
</script>

<style scoped>

</style>